export default {
  // Admin Dashboard
  adminDashboard: "لوحة تحكم المدير",
  adminPanel: "لوحة الإدارة",
  manageCampaigns: "إدارة الحملات",
  campaignManagement: "إدارة الحملات",
  allCampaigns: "جميع الحملات",
  
  // Campaign Status
  statusPending: "قيد الانتظار",
  statusActive: "نشط",
  statusCompleted: "مكتمل",
  statusCancelled: "ملغي",
  statusDraft: "مسودة",
  
  // Actions
  approveCampaign: "الموافقة على الحملة",
  rejectCampaign: "رفض الحملة",
  viewDetails: "عرض التفاصيل",
  editCampaign: "تعديل الحملة",
  deleteCampaign: "حذف الحملة",
  
  // Filters & Sort
  filterByStatus: "تصفية حسب الحالة",
  sortBy: "ترتيب حسب",
  searchCampaigns: "البحث في الحملات",
  
  // Statistics
  totalCampaigns: "إجمالي الحملات",
  activeCampaigns: "الحملات النشطة",
  pendingApproval: "في انتظار الموافقة",
  totalRevenue: "إجمالي الإيرادات",
  
  // Messages
  campaignApproved: "تمت الموافقة على الحملة بنجاح",
  campaignRejected: "تم رفض الحملة",
  campaignDeleted: "تم حذف الحملة",
  confirmDelete: "هل أنت متأكد من حذف هذه الحملة؟",
  
  // Errors
  errorLoadingCampaigns: "خطأ في تحميل الحملات",
  errorUpdatingStatus: "خطأ في تحديث الحالة",
  errorDeletingCampaign: "خطأ في حذف الحملة",
} as const;
